module.exports = __webpack_public_path__ + "img/footer-shequ.c981656c.png";